module.exports = __webpack_public_path__ + "media/images/menu/icn-profile-59413f5b08184da7e018e48b70f92a07.svg";